import { defineStore } from 'pinia'
import api from '@/services/api'

export interface Widget {
  id: string
  name: string
  description?: string
  type: 'KPI' | 'PIE' | 'DOUGHNUT' | 'BAR' | 'LINE' | 'TABLE'
  entityId: string
  query: Record<string, any>
  config: Record<string, any>
  style?: Record<string, any>
  createdBy: string
  copiedFromId?: string
  accessRuleList?: any[]
  createdAt: string
  updatedAt: string
}

export const useScWidgetStore = defineStore('sc-widget', {
  state: () => ({
    widgets: [] as Widget[],
    loading: false,
  }),

  actions: {
    async fetchWidgets() {
      this.loading = true
      try {
        const { data } = await api.get<Widget[]>('/dashboard/widgets')
        this.widgets = data
      } catch (err) {
        console.error('fetchWidgets:', err)
      } finally {
        this.loading = false
      }
    },

    async createWidget(payload: Omit<Widget, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>) {
      try {
        const { data } = await api.post<Widget>('/dashboard/widgets', payload)
        this.widgets.push(data)
        return data
      } catch (err) {
        console.error('createWidget:', err)
        return null
      }
    },

    async updateWidget(id: string, payload: Partial<Omit<Widget, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>>): Promise<Widget | null> {
      try {
        const { data } = await api.put<Widget>(`/dashboard/widgets/${id}`, payload)
        const idx = this.widgets.findIndex(w => w.id === id)
        if (idx !== -1) this.widgets[idx] = data
        return data
      } catch (err) {
        console.error('updateWidget:', err)
        return null
      }
    },

    async deleteWidget(id: string) {
      try {
        await api.delete(`/dashboard/widgets/${id}`)
        this.widgets = this.widgets.filter(w => w.id !== id)
        return true
      } catch (err) {
        console.error('deleteWidget:', err)
        return false
      }
    },
  },
})